import styled from '@emotion/styled'
import { Menu } from '@headlessui/react'
import { ReactNode } from 'react'

import {
  DropdownButton,
  DropdownButtonDesign,
  DropdownButtonSize,
} from './Button'
import { DropdownItem } from './Item'
import { DropdownItems } from './Items'
import { DropdownPropsContextProvider } from './useDropdownProps'
import { DropdownItemsAlignment } from '../../constants'
import { Column } from '../Column'
import { IconName } from '../Icon'
import { Row } from '../Row'

const DropdownElement = styled.div({
  position: 'relative',
})

export type DropdownDesign = DropdownButtonDesign

export type DropdownItem = {
  disabled?: boolean
  icon?: IconName
  key: string
  label: string
  onClick: () => void
  hidden?: boolean
}

export type DropdownProps = {
  alignItems?: DropdownItemsAlignment
  buttonClassName?: string
  buttonIcon?: IconName
  buttonText?: string
  children?: ReactNode
  compact?: boolean
  design?: DropdownDesign
  fullWidth?: boolean
  items: DropdownItem[]
  size?: DropdownButtonSize
}

export type DropdownSize = DropdownButtonSize

export const Dropdown = (props: DropdownProps) => {
  const filteredItems = props.items.filter((item) => !item.hidden)

  if (filteredItems.length === 0) {
    return null
  }

  const iconPlaceholder = props.items.some((item) => item.icon)
    ? null
    : undefined

  return (
    <DropdownPropsContextProvider {...props}>
      <DropdownElement>
        <Menu>
          <Row>
            {props.children}
            <DropdownButton
              className={props.buttonClassName}
              compact={props.compact}
              design={props.design}
              fullWidth={props.fullWidth}
              icon={props.buttonIcon}
              size={props.size}
              text={props.buttonText}
            />
          </Row>
          <Column position="relative">
            <DropdownItems alignItems={props.alignItems}>
              {filteredItems.map((item) => (
                <DropdownItem
                  disabled={item.disabled}
                  icon={item.icon ?? iconPlaceholder}
                  key={item.key}
                  onClick={item.onClick}
                  small={props.size !== 'md'}
                >
                  {item.label}
                </DropdownItem>
              ))}
            </DropdownItems>
          </Column>
        </Menu>
      </DropdownElement>
    </DropdownPropsContextProvider>
  )
}
